import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import InviteManagement from '../components/InviteManagement';
import SuperAdminPanel from '../components/SuperAdminPanel';
import './AdminDashboard.css';

const AdminDashboard: React.FC = () => {
  const navigate = useNavigate();
  const { user, organization } = useAuth();
  const [showInvitePanel, setShowInvitePanel] = useState(false);

  const isSuperAdmin = user?.isSuperAdmin;

  return (
    <div className="admin-dashboard">
      <div className="dashboard-header">
        <div>
          <h1>Admin Dashboard</h1>
          <p>Welcome back, {user?.name}</p>
          {organization && (
            <p className="org-badge">{organization.name}</p>
          )}
        </div>
        <div className="header-actions">
          {organization && (
            <button
              className="button-secondary"
              onClick={() => setShowInvitePanel(!showInvitePanel)}
            >
              👥 {showInvitePanel ? 'Hide' : 'Manage'} Team
            </button>
          )}
          <button
            className="button-secondary"
            onClick={() => navigate('/chat')}
          >
            💬 Access Chat
          </button>
        </div>
      </div>

      {/* Super Admin Panel - only visible to super admins */}
      {isSuperAdmin && <SuperAdminPanel />}

      {/* Team Management - only show when org is selected */}
      {showInvitePanel && organization && (
        <div className="invite-panel-container">
          <InviteManagement />
        </div>
      )}

      <div className="dashboard-cards">
        <div
          className="dashboard-card primary"
          onClick={() => navigate('/admin/tests/create')}
        >
          <div className="card-icon">➕</div>
          <h2>Create/View Tests</h2>
          <p>Create new tests with AI assistance or view existing tests</p>
        </div>

        <div
          className="dashboard-card secondary"
          onClick={() => navigate('/admin/tests/results')}
        >
          <div className="card-icon">📊</div>
          <h2>Test Results</h2>
          <p>View test summaries and employee performance</p>
        </div>

        <div
          className="dashboard-card tertiary"
          onClick={() => navigate('/admin/documents/upload')}
        >
          <div className="card-icon">📁</div>
          <h2>Upload Documents</h2>
          <p>Add documents to the RAG database for AI-powered chat and test generation</p>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
